import { defineStore } from 'pinia';
import axios from 'axios';
import router from '../router/router';

export const useAppStore = defineStore('app', {
  state: () => ({
    isBusiness: false,
    isAlert: false,
    alertContent: '',
    isSuccess: false,
    successContent: '',
    resetPassEmail: '',
    isSubscribed: false,
  }),
  actions: {
    setIsBusiness(value) {
      if (value == 'true') {
        this.isBusiness = false;
      } else if (value == 'false') {
        this.isBusiness = true;
      }
      router.push(`${this.isBusiness ? '/dla-biznesu' : '/'}`);
    },
    setIsAlert(value = 'Wystąpił błąd. Spróbuj ponownie.') {
      this.isAlert = true;
      this.alertContent = value;
      setTimeout(() => {
        this.isAlert = false;
      }, 5000);
    },
    setIsSuccess(value) {
      this.isSuccess = true;
      this.successContent = value;
      setTimeout(() => {
        this.isSuccess = false;
      }, 5000);
    },
    setResetPassEmail(value) {
      this.resetPassEmail = value;
    },
    async setIsSubscribed(user) {
      if (!user || !user.id) {
        this.isSubscribed = false;
        return;
      }

      try {
        const res = await axios.get(`/User/${user.id}`);
        this.isSubscribed = !!res.data.subscription;
      } catch (e) {
        this.isSubscribed = false;
      }
    },
  },
});